import { useEffect, useState } from "react";
import { venueService } from "services/venueService";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

const DEFAULT = {
  sortBy: "venue_price_id",
  filter: 0,
  offset: 0,
  limit: 30,
  order: "desc",
};

const REPEAT_PERIOD = {
  sortBy: "venue_price_id",
  filter: 1,
  offset: 0,
  limit: 30,
  order: "desc",
};

const ONE_TIME_PERIOD = {
  sortBy: "venue_price_id",
  filter: 2,
  offset: 0,
  limit: 30,
  order: "desc",
};

export default function useHomeVenuePrice() {
  const [priceList, setPriceList] = useState<Object | null>();

  useEffect(() => {
    (async function () {
      const res = await Promise.all([
        await venueService.getVenueDefaultPriceByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID)),
        await venueService.getVenueRepeatPeriodPriceByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID), {
          filter: `[venue_prices.status:eq:1]`,
        }),
        await venueService.getVenueOneTimePeriodPriceByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID), {
          filter: `[venue_prices.status:eq:1]`,
        }),
      ]);

      setPriceList({
        default: res[0],
        repeat: res[1],
        otp: res[2],
      });
    })();
  }, []);

  return { priceList };
}
